import { CM, Tction } from '@tkit/model';
import { TkitUtils as Utils } from '@tkit/types';
import {
  APIS,
  ParamstopicTopicIdUsingGet,
  TopicInfoVO,
  ParamstopicDeleteTopicIdUsingPut,
  ParamstopicGroupIdGroupUsingGet,
  ParamsBodytopicPublishUsingPost,
  ParamstopicTopicIdCommentUsingGet,
  PageableResulttopicInfoVO,
  ParamsBodytopicPublishCommentUsingPost,
  PageableResulttopicCommentInfoVO,
  TopicCommentInfoVO
} from '@src/services';
import { message } from 'antd';

export interface State {
  topicInfoLoad: boolean;
  topicInfo: TopicInfoVO;
  /** 帖子 */
  topicListModel: PageableResulttopicInfoVO;
  topicListLoad: boolean;
  topicComModel: PageableResulttopicCommentInfoVO;
  topicComLoad: boolean;
}

export const topicModelState: State = {
  topicInfoLoad: false,
  topicInfo: {},
  topicListModel: {},
  topicListLoad: false,
  topicComModel: {},
  topicComLoad: false
};

const model = CM({
  state: topicModelState,
  namespace: 'topicModel',
  reducers: {
    /**
     * @description 设置获取帖子详情时的loading
     */
    setTopicInfoLoad: (state, action: Tction<boolean>) => {
      return {
        ...state,
        topicInfoLoad: action.payload
      };
    },
    /**
     * @description 设置帖子详情
     */
    setTopicInfo: (state, action: Tction<TopicInfoVO>) => {
      return {
        ...state,
        topicInfo: action.payload
      };
    },
    /**
     * @description 删除帖子
     */
    removeTopic: (state, action: Tction<string>) => {
      const {
        topicListModel: { list = [] },
        topicListModel: oldModel
      } = state;

      return {
        ...state,
        topicListModel: {
          ...oldModel,
          list: list.filter(item => item.topicId !== action.payload)
        }
      };
    },
    /**
     * @description 设置帖子列表
     */
    setTopicList: (state, action: Tction<{ topicListModel: PageableResulttopicCommentInfoVO }>) => {
      const { topicListModel } = action.payload;
      return {
        ...state,
        topicListModel
      };
    },
    /**
     * @description 设置帖子列表loading
     */
    setTopicListload: (state, action: Tction<boolean>) => {
      return {
        ...state,
        topicListLoad: action.payload
      };
    },
    /**
     * @description 设置帖子评论
     */
    setTopicListCom: (state, action: Tction<PageableResulttopicInfoVO>) => {
      return {
        ...state,
        topicComModel: action.payload
      };
    },
    /**
     * @description 设置帖子评论load
     */
    setTopicComload: (state, action: Tction<boolean>) => {
      return {
        ...state,
        topicComLoad: action.payload
      };
    },
    /**
     * @description 设置帖子评论load
     */
    addNewTopicCom: (state, action: Tction<TopicInfoVO>) => {
      const {
        topicComModel: oldModel,
        topicComModel: { list = [], total = 0 }
      } = state;
      const topicComModel = {
        ...oldModel,
        list: [action.payload, ...list],
        total: total + 1
      };

      return {
        ...state,
        topicComModel
      };
    },
    /**
     * @description 删除回帖
     */
    removeTopicReply: (state, action: Tction<string>) => {
      const {
        topicComModel: oldModel,
        topicComModel: { list = [], total = 0 }
      } = state;
      const topicComModel = {
        ...oldModel,
        list: list.filter(item => item.topicCommentId !== action.payload),
        total: total - 1
      };

      return {
        ...state,
        topicComModel
      };
    },
    /**
     * @description 设置某一个回帖
     */
    setTopicReply: (state, action: Tction<TopicCommentInfoVO>) => {
      const {
        topicComModel: oldModel,
        topicComModel: { list = [] }
      } = state;
      const topicComModel = {
        ...oldModel,
        list: list.map(item => {
          if (item.topicCommentId === action.payload.topicCommentId) {
            return action.payload;
          } else {
            return item;
          }
        })
      };

      return {
        ...state,
        topicComModel
      };
    },
    /**
     * @description 设置更多回帖
     */
    setMoreTopicReply: (state, action: Tction<PageableResulttopicCommentInfoVO>) => {
      const {
        topicComModel: { list: oldList = [] }
      } = state;
      const { list: newList = [] } = action.payload;

      return {
        ...state,
        topicComModel: {
          ...action.payload,
          list: [...oldList, ...newList]
        }
      };
    }
  },
  effects: {
    /**
     * @description 获取帖子详情
     */
    *getTopicInfoAsync(
      { namespace, put, tPut, tCall },
      action: Tction<ParamstopicTopicIdUsingGet>
    ): Iterator<{}, any, any> {
      yield tPut(model.actions.setTopicInfoLoad, true);
      const data: Utils.GetROA<typeof APIS.TopicApi.topicTopicIdUsingGet> = yield tCall(
        APIS.TopicApi.topicTopicIdUsingGet,
        action.payload
      );

      if (data.code === 0 && data.result) {
        yield tPut(model.actions.setTopicInfo, data.result);
      }

      yield tPut(model.actions.setTopicInfoLoad, false);
    },
    /**
     * @description 删除帖子
     */
    *removeTopicAsync(
      { namespace, put, tPut, tCall },
      action: Tction<{
        params: ParamstopicDeleteTopicIdUsingPut;
        callback?: () => void;
      }>
    ): Iterator<{}, any, any> {
      const { callback, params } = action.payload;
      const data: Utils.GetROA<typeof APIS.TopicApi.topicDeleteTopicIdUsingPut> = yield tCall(
        APIS.TopicApi.topicDeleteTopicIdUsingPut,
        params
      );

      if (data.code === 0) {
        callback && callback();
        message.success('删除成功');
        yield tPut(model.actions.removeTopic, params.topicId);
      } else {
        message.error(data.message);
      }
    },
    /** 获取帖子列表 */
    *getTopicList(
      { tPut, tCall },
      action: Tction<{
        params: ParamstopicGroupIdGroupUsingGet;
        callback?: () => void;
      }>
    ): Iterator<{}, any, any> {
      yield tPut(model.actions.setTopicListload, true);

      const { params, callback } = action.payload;
      const res: Utils.GetROA<typeof APIS.TopicApi.topicGroupIdGroupUsingGet> = yield tCall(
        APIS.TopicApi.topicGroupIdGroupUsingGet,
        params
      );
      if (res.code === 0) {
        yield tPut(model.actions.setTopicList, { topicListModel: res.result || {} });
        callback && callback();
      } else {
        message.error(res.message);
      }

      yield tPut(model.actions.setTopicListload, false);
    },
    /** 发布帖子 */
    *publishTopic(
      { tPut, tCall },
      action: Tction<{
        data: ParamsBodytopicPublishUsingPost;
        callBack?: () => void;
      }>
    ): Iterator<{}, any, any> {
      const { data, callBack } = action.payload;
      const res: Utils.GetROA<typeof APIS.TopicApi.topicPublishUsingPost> = yield tCall(
        APIS.TopicApi.topicPublishUsingPost,
        data
      );

      if (res.code === 0) {
        message.success('发布成功');
        callBack && callBack();
      } else {
        message.error(res.message);
      }
    },
    /**
     * @description 获取帖子评论
     */
    *getTopicCommentAsync(
      { tPut, tCall },
      action: Tction<{
        data: ParamstopicTopicIdCommentUsingGet;
        callBack?: () => void;
      }>
    ): Iterator<{}, any, any> {
      yield tPut(model.actions.setTopicComload, true);
      const { data, callBack } = action.payload;
      const res: Utils.GetROA<typeof APIS.TopicApi.topicTopicIdCommentUsingGet> = yield tCall(
        APIS.TopicApi.topicTopicIdCommentUsingGet,
        data
      );

      if (res.code === 0 && res.result) {
        yield tPut(model.actions.setTopicListCom, res.result);
      } else {
        message.error(res.message);
      }

      yield tPut(model.actions.setTopicComload, false);
    },
    /**
     * @description 回帖评论
     */
    *replayTopicAsync(
      { tPut, tCall },
      action: Tction<{
        data: ParamsBodytopicPublishCommentUsingPost;
        callBack?: (data: TopicInfoVO) => void;
      }>
    ): Iterator<{}, any, any> {
      const { data, callBack } = action.payload;
      const res: Utils.GetROA<typeof APIS.TopicApi.topicPublishCommentUsingPost> = yield tCall(
        APIS.TopicApi.topicPublishCommentUsingPost,
        data
      );

      if (res.code === 0 && res.result) {
        callBack && callBack(res.result);
      } else {
        message.error(res.message);
      }
    },
    /**
     * @description 删除评论/回帖
     */
    *removeTopicComAsync(
      { tPut, tCall },
      action: Tction<{
        data: { topicCommentId: string };
        callBack?: () => void;
      }>
    ): Iterator<{}, any, any> {
      const { data, callBack } = action.payload;
      const res: Utils.GetROA<typeof APIS.TopicApi.topicDeleteCommentTopicCommentIdUsingPut> = yield tCall(
        APIS.TopicApi.topicDeleteCommentTopicCommentIdUsingPut,
        data
      );

      if (res.code === 0) {
        callBack && callBack();
      } else {
        message.error(res.message);
      }
    },
    /**
     * @description 获取更多回帖
     */
    *getMoreTopicComAsync(
      { tPut, tCall },
      action: Tction<{
        data: ParamstopicTopicIdCommentUsingGet;
        callBack?: () => void;
      }>
    ): Iterator<{}, any, any> {
      const { data, callBack } = action.payload;
      const res: Utils.GetROA<typeof APIS.TopicApi.topicTopicIdCommentUsingGet> = yield tCall(
        APIS.TopicApi.topicTopicIdCommentUsingGet,
        data
      );

      if (res.code === 0 && res.result) {
        yield tPut(model.actions.setMoreTopicReply, res.result);
        callBack && callBack();
      } else {
        message.error(res.message);
      }

      yield tPut(model.actions.setTopicComload, false);
    }
  }
});

/**
 * @description 全局Model topicModel 挂载到 redux 上
 */
export default model;
